import * as React from 'react'

import { cn } from '../../lib/utils'
import { Search } from 'lucide-react'
import { Button } from './button'

const MobileSearchInput = React.forwardRef(
  ({ className, handleSearchCancel, type, ...props }, ref) => {
    return (
      <div className='relative max-w-2xl mx-auto w-full pt-safe'>
        <div className='fabits-search-shell relative flex items-center rounded-full'>
          <Search className='absolute left-4 h-[14px] w-[14px]' />

          <input
            type={type}
            className={cn(
              'pl-12 pr-24 flex h-10 w-full rounded-full border-0 bg-transparent text-sm font-normal ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[var(--fb-text-subtle)] placeholder:font-normal placeholder:text-sm placeholder:leading-5 focus-visible:outline-none focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50',
              className,
            )}
            ref={ref}
            {...props}
          />

          <Button
            variant='ghost'
            onClick={() => handleSearchCancel()}
            className='absolute right-2 rounded-none border-l-[1px] px-4 text-sm text-[var(--fb-text-muted)] hover:bg-transparent focus:bg-transparent'
          >
            Cancel
          </Button>
        </div>
      </div>
    )
  },
)

MobileSearchInput.displayName = 'Mobile Search Input'

export { MobileSearchInput }
